import { ActionsSubject, Store } from '@ngrx/store';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import * as fromCompanySettingsStore from '../../../../settings/store';
import { AbstractModal } from '../AbstractModal';
import { CompanySettings } from '../../../../settings/model/company-settings';
import { ModalService } from '../modal.service';
import { SAVE_COMPANY_SETTINGS_SUCCESS } from '../../../../settings/store';

@Component({
  selector: 'ls-timezone-modal',
  templateUrl: './timezone-modal.component.html'
})
export class TimezoneModalComponent extends AbstractModal
  implements OnInit, OnDestroy {
  public timeZoneForm: FormGroup;
  @Input()
  public data: any;
  private unsubscriber$: Subject<Subscription> = new Subject();

  constructor(
    private fb: FormBuilder,
    protected store: Store<fromCompanySettingsStore.CompanyState>,
    private modal: ModalService,
    private actionsSubject: ActionsSubject
  ) {
    super();
    this.overflowVisible = true;
  }

  public ngOnInit(): void {
    this.timeZoneForm = this.fb.group({
      timeZone: [null, Validators.required]
    });
  }

  public onSubmit(): void {
    const companySettings: CompanySettings = Object.assign(
      {},
      { ...this.data.companySettings }
    );
    companySettings.timeZone = this.timeZoneForm.value.timeZone;
    this.store.dispatch(
      new fromCompanySettingsStore.SaveCompanySettings({
        settings: companySettings
      })
    );

    this.actionsSubject
      .pipe(takeUntil(this.unsubscriber$))
      .subscribe((data: any) => {
        if (data.type === SAVE_COMPANY_SETTINGS_SUCCESS) {
          this.modal.close();
        }
      });
  }

  public close(): void {
    this.modal.close();
  }

  public ngOnDestroy(): void {
    this.unsubscriber$.next();
    this.unsubscriber$.complete();
  }
}
